// extracted by mini-css-extract-plugin
export default {"oddsButton":"Odds_oddsButton__e1c48"};